import { EntrySelect } from './../models/EntrySelect.model';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserSession, dCurrentEmpresa } from '../models/user-session.model';
import { environment } from '../../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private privateKey: string = "7431ad12bf9a661dd2da57bb6ea493c6ec78847b471962f106d3bf2acf4b259a";
  private readonly keyCurrentSession = 'orcamentacao-current-session';
  private sessionSubject = new Subject<UserSession>();
  public isLogado = new Subject<boolean>();

  parseDadosLoginRest(userSession:UserSession, Secret_Key:string, dados:any){
              //requer validação?
              let validarToken = dados.validarToken;
              let idPlan = dados.controlAccess?.idPlan;
              if (idPlan == undefined) idPlan = "";
              //grava sessão   
              //obtenção dos dados base para funcionamento do sistema
              userSession.token = dados.controlAccess.transactionHash;
              userSession.login = dados.login;
              userSession.razaoSocial = dados.razaoSocial;
              userSession.cnpjEmpresa = dados.cnpjEmpresa;
              userSession.master = dados.master == 'true';
              userSession.currentEmpresa = {
                'tipo': dados.controlAccess?.tipo_empresa,
                "cnpj": dados.cnpjEmpresa,
                'secretKey': Secret_Key,
                'razaoSocial': dados.razaoSocial,
                'uuid': dados.controlAccess?.uuid_empresa,
                "idPlan": idPlan
              };
              userSession.grupo = dados.controlAccess?.grupoPerfil;
              userSession.grupo_id = dados.controlAccess?.idGrupo;
              userSession.tipo_empresa = dados.controlAccess?.tipo_empresa;
              userSession.uuid_empresa = dados.controlAccess?.uuid_empresa;
              userSession.idPlan = idPlan;              
              userSession.uuidUsuario = dados.uuidUsuario;
              userSession.nomeUsuario = dados.nomeUsuario;
             
              if (dados?.chaveCr)//caso a chave de criptografia seja informada ela é armazenada
                this.setChaveCrypto(dados.chaveCr)
              if (validarToken != 'SIM') {
                userSession.logado = true;
              }
          return userSession;

  }
  
  getPrivateKey() {
    return this.privateKey + "#" + this.getEmail();
  }

  setStorage(key, value) {
    localStorage.setItem(this.keyCurrentSession, CryptoJS.AES.encrypt(value, this.getPrivateKey()).toString());
  }

  setStoragePersonalizado(key, value) {
    localStorage.setItem(key, CryptoJS.AES.encrypt(value, this.getPrivateKey()).toString());
  }

  getUUIDUsuario() {
    return this.getCurrentSession().uuidUsuario;
  }

  setUrlWebSocket(url) {
    localStorage.setItem(this.keyCurrentSession + 'url', CryptoJS.AES.encrypt(url, this.getPrivateKey()).toString());
  }

  setChaveCrypto(chave) {
    localStorage.setItem(this.keyCurrentSession + 'CC', CryptoJS.AES.encrypt(chave, this.getPrivateKey()).toString());
  }

  getStorage(key) {
    let value = localStorage.getItem(key);
    if (value) {
      try {
        return CryptoJS.AES.decrypt(value, this.getPrivateKey()).toString(CryptoJS.enc.Utf8)
      } catch (e) {
        //console.error(e);
        return null;
      }
    } else {
      return null
    }
  }

  setCurrentSession(sessionDto: UserSession): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      await this.setStorage(this.keyCurrentSession, JSON.stringify(sessionDto));
      this.sessionSubject.next(sessionDto);
      /*if(sessionDto.logado){
        this.isLogado.next(true);
      }else{
        this.isLogado.next(false);
      }*/
      resolve(true);
    });
  }

  retornaLogin() {
    return this.getCurrentSession().login;
  }

  setCurrentSinistro(idSinistro: number): void {
    let userSession = this.getUserSession();
    //userSession.idSinistro = idSinistro;
    this.setCurrentSession(userSession);
  }

  setCurrentTokenCiclo(token: string) {
    let userSession = this.getUserSession();
    userSession.TokenCiclo = token;
    this.setCurrentSession(userSession);
  }

  setCurrentToken(token: string) {
    let userSession = this.getUserSession();
    userSession.token = token;
    this.setCurrentSession(userSession);
  }

  getCurrentToken() {
    return this.getUserSession().token;
  }

  setSecretKey(secret: string): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let userSession = this.getUserSession();
      userSession.secretKey = secret;
      await this.setCurrentSession(userSession);
      resolve(true);
    });
  }

  getUUIDEmpresa() {
    return this.getUserSession().uuid_empresa;
  }

  getSecretKey() {
    return this.getUserSession().secretKey;
  }
  getApiAccessKey() {
    return this.getUserSession().ApiAccessKey;
  }

  getCargo() {
    return this.getUserSession().grupo_id
  }

  setEmail(value: string) {
    localStorage.setItem(this.keyCurrentSession + "_email", value);
  }

  getEmail() {
    const value = localStorage.getItem(this.keyCurrentSession + "_email");
    if (value) {
      return value;
    }
    return "";
  }

  getRazaoSocial() {
    let i = this.getUserSession();
    return i.razaoSocial;
  }

  getTipoEmpresa(user: boolean = false) {
    let i = this.getUserSession();
    if (user) {
      return i.tipo_empresa
    } else {
      return i.currentEmpresa?.tipo;
    }
  }

  getPlanId(user: boolean = false) {
    let idPlan = null;
    if (user) {
      idPlan = this.getUserSession()?.idPlan;
    } else {
      idPlan = this.getCurrentEmpresa()?.idPlan;
    }
    if (idPlan == "") {
      idPlan = null;
    }
    return idPlan;
  }

  getUserSession(): UserSession {
    let userSession: UserSession;
    if (this.hasCurrentSession()) {
      userSession = this.getCurrentSession();
    } else {
      userSession = new UserSession();
    }
    //check isLogado
    if (userSession.logado) {
      this.isLogado.next(true);
    } else {
      this.isLogado.next(false);
    }

    return userSession;
  }

  hasCurrentSession(): boolean {
    return this.getStorage(this.keyCurrentSession) !== null;
  }

  getCurrentSession(): UserSession {
    return JSON.parse(this.getStorage(this.keyCurrentSession));
  }

  getCurrentWebSocketUrl(): UserSession {
    return (this.getStorage(this.keyCurrentSession + 'url'));
  }

  getCurrentChaveCrypto(): any {
    return (this.getStorage(this.keyCurrentSession + 'CC'));
  }

  clear(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      await localStorage.removeItem(this.keyCurrentSession);
      this.sessionSubject.next(new UserSession);
      this.isLogado.next(false);
      resolve(true);
    });
  }

  getSessionSubject() {
    return this.sessionSubject;
  }

  isAuthenticated() {
    return this.getUserSession().logado;
  }

  //profile currentEmpresa
  getCurrentEmpresa(): dCurrentEmpresa {
    return this.getUserSession().currentEmpresa;
  }

  setCurrentEmpresa(value: dCurrentEmpresa) {
    let userSession = this.getUserSession();
    userSession.currentEmpresa = value;
    this.setCurrentSession(userSession);
  }

  getCurrentSecretKeyEmpresa() {
    let current = this.getCurrentEmpresa();
    if (current) {
      return current.secretKey;
    }
  }

  getCurrentRazaoSocial() {
    let current = this.getCurrentEmpresa();
    if (current) {
      return current.razaoSocial;
    }
  }

  checkInGrupo(grupoIds: Array<any> = []) {
    const grupoId = this.getCurrentSession()?.grupo_id;
    //in grupo?
    if (grupoId != undefined && grupoIds.length > 0 && grupoIds.includes(Number.parseInt(grupoId))) {
      return true;
    }
    return false;
  }

  isMaster(user: boolean = false) {//retorna true se o usuário for um usuário da Arco
    if (user) {
      return environment.empresa_master == this.getSecretKey();
    } else {
      return environment.empresa_master == this.getCurrentEmpresa().secretKey;
    }
  }

  isCorporate() {
    let tipo = this.getTipoEmpresa();
    return tipo == 'CORPORATE';
  }

  isReguladora() {
    let tipo = this.getTipoEmpresa();
    return tipo == 'REGULADORA';
  }

  isOficina() {
    let tipo = this.getTipoEmpresa();
    return tipo == 'OFICINA';
  }


  isCiclo(): boolean {//retorna se o usuário em questão é usuário da empresa ciclo
    return environment.empresa_ciclo == this.getSecretKey();
  }

  heUserMaster(): boolean {//retorna true caso o usuário em questão é usuário master da empresa
    let session: UserSession = this.getCurrentSession();
    return session.master ? session.master : false;
  }

  getNomeUsuario(): string {//obtem o nome do usuário salvo no localStorage
    let session: UserSession = this.getCurrentSession();
    return session.nomeUsuario;
  }

  obterUrlWebSocket(): string {//obtem a url do webSocket salva no localStorage
    let session: any = this.getCurrentWebSocketUrl();
    return session;
  }

}
